// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__3jayy","empty":"ModalGraph_empty__rRzoO"};